module.exports = __webpack_public_path__ + "static/stripe-billing-847c92de555aacaef51273843f38e419.png";